import { Badge } from '@amzn/awsui-components-core';
import SideNavigation, { SideNavigationProps } from '@amzn/awsui-components-core/side-navigation';
import React, { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getOperationalExcellenceNavigationItems } from 'src/utilities/RouteConfig';
import { FinTechOpsHref } from '../FinTechOpsConstants';
import { useOEReportLinkVisible } from '../oe-report/access/useOEReportLinkVisible';
import { Titles } from 'src/components/das-finsuite/das-finsuite-constants';

const NAV_ORDER: string[] = [
  FinTechOpsHref.oeInsights,
  FinTechOpsHref.userMetrics,
  FinTechOpsHref.tickets,
  FinTechOpsHref.kpiMetrics,
  FinTechOpsHref.costMetrics,
  FinTechOpsHref.sas,
  FinTechOpsHref.policyEngine,
  FinTechOpsHref.dogma,
  FinTechOpsHref.riskRemediator,
  FinTechOpsHref.upgradeMedic,
  FinTechOpsHref.dataMapping,
  FinTechOpsHref.oeReportGenerator,
  FinTechOpsHref.pipelineOEDashboard,
  FinTechOpsHref.oeReport
];

export const OESideNavigation: React.FC = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  // Limited preview: the link is shown only to allowlisted aliases, though the route
  // stays reachable by URL.
  const showOEReport = useOEReportLinkVisible();

  const items = useMemo<SideNavigationProps.Item[]>(() => {
    const allItems = getOperationalExcellenceNavigationItems().filter((item): item is SideNavigationProps.Link => item.type === 'link');
    const ordered = NAV_ORDER.map((href) => allItems.find((item) => item.href === href)).filter(Boolean) as SideNavigationProps.Link[];
    return (
      ordered
        .filter((item) => item.href !== FinTechOpsHref.oeReport || showOEReport)
        // Add a NEW badge to the Interactive OE Report link.
        .map((item) => (item.href === FinTechOpsHref.oeReport ? { ...item, info: <Badge color="green">NEW</Badge> } : item))
    );
  }, [showOEReport]);

  const handleFollow: SideNavigationProps['onFollow'] = (event) => {
    event.preventDefault();
    navigate(event.detail.href);
  };

  return (
    <SideNavigation
      activeHref={pathname}
      header={{ text: Titles.TITLE_OP_EX, href: FinTechOpsHref.finTechOps }}
      items={items}
      onFollow={handleFollow}
    />
  );
};
